import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryContants } from "../../../constant";
import {
  buyVip,
  cancelPaymentPayOS,
  createPayment,
  createPaymentPayOS,
  updatePaymentOrderStatus,
  updateVip,
  createQRPayment,
  cancelQRPayment,
} from "../../../apis/payment/payment";

export const useCreatePaymentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPayment,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};

export const useBuyVipMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: buyVip,
    onSuccess: () => {
      queryClient.invalidateQueries([
        queryContants.GET_ME,
        queryContants.GET_AMOUNT_HISTORY,
        queryContants.GET_PAYMENT_HISTORY,
      ]);
    },
  });
};
export const useUpdatePaymentOrderStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePaymentOrderStatus,
    onSuccess: () => {
      queryClient.invalidateQueries([
        queryContants.GET_ME,
        queryContants.GET_AMOUNT_HISTORY,
        queryContants.GET_PAYMENT_HISTORY,
      ]);
    },
  });
};

export const useUpdateVipMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateVip,
    onSuccess: () => {
      queryClient.invalidateQueries([
        queryContants.GET_ME,
        queryContants.GET_AMOUNT_HISTORY,
        queryContants.GET_PAYMENT_HISTORY,
        queryContants.GET_VIP_ORDER,
      ]);
    },
  });
};

// Legacy PayOS (keeping for backward compatibility)
export const useCreatePaymentPayOSMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPaymentPayOS,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};

export const useCancelPayOSOrderMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelPaymentPayOS,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};

// ==================== NEW AUTO PAYMENT QR ====================
export const useCreateQRPaymentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createQRPayment,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};

export const useCancelQRPaymentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelQRPayment,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};
